import React, { Component } from "react"
import { Link, Redirect } from "react-router-dom"
import config from "react-global-configuration"
import * as path from "../../constants/Paths"
import * as endpoints from "../../constants/Endpoints"
import * as dateHelper from "../../helpers/date"
import QueryString from "query-string"
import BookingAmendmentProducts from "../common/bookingAmendmentProducts"
import * as moment from "moment"
import QRCode from "qrcode.react"
import * as storageHelper from "../../../helpers/storageHelper"
import ActionModal from "./amendActionModal"

class AmendManage extends Component {
  constructor(props) {
    super(props)

    this.state = {
      isModalLoaded: false,
    }
  }

  componentDidMount() {
    storageHelper.removeFromSessionStorage("emailUpgradeGuid")
    this.props.setDataToState({ emailUpgradeGuid: null })
  }

  flipModalState = () => {
    this.setState({
      isModalLoaded: !this.state.isModalLoaded,
    })
  }

  canEditInformation = (booking) => {
    if (moment().isBefore(`${booking.departureDate} ${booking.departureTime}`)) {
      return true
    }
    return false
  }

  isBookingPassed = (booking) => {
    if (moment().isBefore(`${booking.departureDate} ${booking.departureTime}`)) {
      return true
    }
    return false
  }

  isBookingActive = (booking) => {
    if (moment().isAfter(`${booking.arrivalDate} ${booking.arrivalTime}`) && moment().isBefore(`${booking.departureDate} ${booking.departureTime}`)) {
      return true
    }
    return false
  }

  isBookingPending = (booking) => {
    const limitDateTime = moment(`${booking.arrivalDate} ${booking.arrivalTime}`)
    if (moment().isBefore(limitDateTime) && booking.status !== "CX") {
      return true
    }
    return false
  }

  canEditExitTime = (booking) => {
    if (moment().isBefore(`${booking.departureDate} ${booking.departureTime}`)) {
      return true
    }
    return false
  }

  canEditBooking = (cancellationInfo) => {
    /* cancellationActionStatus
      CancellationEnabled = You can edit booking
      CancellationDisabledQuarantined = Booking starts in less than 1 hour, you can no longer edit.
      CancellationDisabledPastEntryTime = Booking has started, you can no longer edit.
    */
    if (cancellationInfo?.cancellationActionStatus === "CancellationEnabled") return true
    return false
  }

  // TODO: Figure out what property from ADVAM deciding when amendable exit time is.
  // return this.isFullValueCancellation() || this.isExtendedRefundCancellationActive()
  isFullValueCancellation = () => {
    if (this.props.manageBookingResult && this.props.manageBookingResult.cancellationInfo)
      return moment().isBefore(this.props.manageBookingResult.cancellationInfo.fullValueCancellationDeadline)
    return false
  }

  isExtendedRefundCancellation = () => {
    if (this.props.manageBookingResult && this.props.manageBookingResult.cancellationInfo)
      return this.props.manageBookingResult.cancellationInfo.isRefundGuaranteeActive // moment().isBefore(this.props.manageBookingResult.cancellationInfo.extendedRefundDeadline)
    return false
  }

  isExtendedRefundCancellationActive = () => {
    if (this.props.manageBookingResult && this.props.manageBookingResult.cancellationInfo)
      return (
        this.props.manageBookingResult.cancellationInfo.isRefundGuaranteeActive &&
        moment().isBefore(this.props.manageBookingResult.cancellationInfo.extendedRefundDeadline)
      )
    return false
  }

  getDate = (date) => {
    const day = dateHelper.formatDate(date, "dddd")
    const formattedDay = day.charAt(0).toUpperCase() + day.slice(1)
    const formattedDate = dateHelper.formatDate(date, "DD/MM/YYYY")
    return `${formattedDay} ${formattedDate}`
  }
  reloadMethod = () => {
    setTimeout(() => {
      console.log("Waiting . . .")
    }, 1000)
    window.location.reload(true)
  }
  // shortcut
  handleCancellation = () => {
    const { manageBookingResult } = this.props

    this.props.cancelBooking(manageBookingResult.booking.guid, this.reloadMethod)
  }

  getRefundedValue = () => {
    if (this.props.manageBookingResult && this.props.manageBookingResult.booking && this.props.manageBookingResult.booking.payments) {
      const refundPayment = this.props.manageBookingResult.booking.payments.find((p) => p.refundReason)
      if (refundPayment) {
        return refundPayment.amount
      }
    }
    return 0
  }

  getBookingStatus = (booking) => {
    const textKeys = config.get("textKeys.amendment.manage") || {}
    switch (booking.status.trim()) {
      // case 'C': return     { bookingStatusText:  textKeys.statusConfirmed          || "Bekræftet",   bookingStatusClass: 'statusbar__yellow'}
      // case 'CA' : return   { bookingStatusText:  textKeys.statusAmmended           || "Ændret",      bookingStatusClass: 'statusbar__yellow'}
      // case 'CX' : return   { bookingStatusText:  textKeys.statusCancelled          || "Annulleret",  bookingStatusClass: 'statusbar__red'}
      // case 'CXN' : return  { bookingStatusText:  textKeys.statusCancelledNoShow    || "Udeblevet",   bookingStatusClass: 'statusbar__red'}
      // case 'CO' : return   { bookingStatusText:  textKeys.statusUpgraded           || "Opgraderet",  bookingStatusClass: 'statusbar__yellow'}
      // case 'COE' : return  { bookingStatusText:  textKeys.statusUpgradedByEmail    || "Opgraderet",  bookingStatusClass: 'statusbar__yellow'}
      // case 'P' : return    { bookingStatusText:  textKeys.statusInProcess          || "Venter",      bookingStatusClass: 'statusbar__yellow'}
      // case 'R' : return    { bookingStatusText:  textKeys.statusInReserved         || "Reserveret",  bookingStatusClass: 'statusbar__yellow'}
      // case 'PR' : return   { bookingStatusText:  textKeys.statusInCapacityReleaseCancel  || "CapacityReleaseCancel", bookingStatusClass: 'statusbar__yellow'}
      // default: return      { bookingStatusText:  textKeys.statusUnknown            || 'Ukendt status', bookingStatusClass: 'statusbar__yellow'}
      case "C": // statusConfirmed || "Bekræftet"
      case "CA": // statusAmmended || "Ændret"
      case "CO": // statusUpgraded || "Opgraderet", bookingStatusClass: 'statusbar__yellow'}
      case "COE": // statusUpgradedByEmail || "Opgraderet", bookingStatusClass: 'statusbar__yellow'}
        if (this.isBookingPending(booking))
          return { bookingStatusText: textKeys.statusPending || "Kommende", bookingStatusClass: "statusbar__yellow" }

        if (this.isBookingActive(booking)) return { bookingStatusText: textKeys.statusActive || "Aktiv", bookingStatusClass: "statusbar__green" }

        return { bookingStatusText: textKeys.statusFormer || "Tidligere", bookingStatusClass: "statusbar__grey" }

      case "CX":
        return { bookingStatusText: textKeys.statusCancelled || "Annulleret", bookingStatusClass: "statusbar__red" }
      case "CXN":
        return { bookingStatusText: textKeys.statusCancelledNoShow || "Udeblevet", bookingStatusClass: "statusbar__red" }

      case "P":
        return { bookingStatusText: textKeys.statusInProcess || "Venter", bookingStatusClass: "statusbar__yellow" }
      case "R":
        return { bookingStatusText: textKeys.statusInReserved || "Reserveret", bookingStatusClass: "statusbar__yellow" }
      case "PR":
        return { bookingStatusText: textKeys.statusInCapacityReleaseCancel || "CapacityReleaseCancel", bookingStatusClass: "statusbar__yellow" }
      default:
        return { bookingStatusText: textKeys.statusUnknown || "Ukendt status", bookingStatusClass: "statusbar__red" }
    }
  }

  render() {
    const textKeys = config.get("textKeys.amendment.manage") || {}

    const queryParam = QueryString.parse(this.props.location.search)
    if (!this.props.manageBookingResult && (!queryParam.email || !queryParam.reference)) return <Redirect to={path.AMMEND_SEARCH()} />
    if (!this.props.manageBookingResult) return null
    const { booking, carPark, product, parking, cancellationInfo, extras } = this.props.manageBookingResult
    const fullRefundValue = (cancellationInfo && cancellationInfo.monetaryRefundValue) || 0
    const refundGuarantee = extras.find((extra) => extra.showBookingPage)
    const canEditInformation = this.canEditInformation(booking)
    const canEditBooking = this.canEditBooking(cancellationInfo)
    const canEditExitTime = this.canEditExitTime(booking)

    const isCancelled = parking.isCancelled

    const refundedValue = this.getRefundedValue()
    if (!booking) return ""

    const query = {
      ad: booking.arrivalDate,
      at: booking.arrivalTime,
      dd: booking.departureDate,
      dt: booking.departureTime,
      voucher: booking.voucher,
      affiliate: booking.affiliateCode,
      cfguid: booking.guid,
      email: booking.email,
      reference: booking.reference,
    }

    const now = new Date(Date.now())
    const bookingDate = booking.arrivalDate
    const bookingTime = booking.arrivalTime

    const bookingDateTime = new Date(`${bookingDate}T${bookingTime}`)
    const isBookingActive = now >= bookingDateTime

    const { bookingStatusText, bookingStatusClass } = this.getBookingStatus(booking)
    return (
      <div className="amendflow">
        <section className="deck deck--white deck--padding-bottom">
          <span className="linktext-wrapper w--wider">
            <a href={path.AMMEND_SEARCH()} className="link">
              {textKeys.backToSearch || "Tilbage til Søgning"}
            </a>
          </span>
          <div className="w--wider greybg">
            <div className={`statusbar ${bookingStatusClass}`}>
              <div className="leftside">{textKeys.status}</div>
              <div className="rightside"> {bookingStatusText}</div>
            </div>
            <div className="amenddata">
              {/* {booking && !parking.isCancelled && (booking.barcodeValue || booking.qrCode) ? */}
              <div className={`qrcode ${bookingStatusText === "Annulleret" ? "cancelled" : ""}`}>
                <QRCode value={booking.barcodeValue || booking.qrCode} size={164} includeMargin={true} />
                <p>&nbsp;</p>
              </div>
              {/* : ""} */}
              {booking ? (
                <div className="data">
                  <div className="info-grid">
                    <div className="grid-item grid-topline">
                      {booking.vehicleRegistrationNumber ? (
                        <h4>{textKeys.vehichleText ? textKeys.vehichleText.vehicleRegistrationNumber || "Registreringsnr." : "Registreringsnr."}</h4>
                      ) : (
                        <h4>
                          {textKeys.vehichleText
                            ? textKeys.vehichleText.vehicleNoRegistration || "Booking informationer"
                            : "Registreringsoplysninger"}
                        </h4>
                      )}

                      <a href={canEditInformation && !parking.isCancelled ? `${path.AMMEND_EDIT_INFO()}${this.props.location.search}` : ""}>
                        {booking.vehicleRegistrationNumber ? (
                          <h4 className="licensplate">
                            <svg width="8" height="7" viewBox="0 0 8 7" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path
                                d="M3.41667 6.41667C3.41667 6.0945 3.67783 5.83333 4 5.83333L4.10486 5.84273L4.20354 5.86983C4.42534 5.95242 4.58333 6.16609 4.58333 6.41667C4.58333 6.73883 4.32217 7 4 7C3.67783 7 3.41667 6.73883 3.41667 6.41667Z"
                                fill="white"
                              />
                              <path
                                d="M1.52513 5.97487C1.29732 5.74707 1.29732 5.37772 1.52513 5.14991C1.75293 4.92211 2.12228 4.92211 2.35008 5.14991C2.57789 5.37772 2.57789 5.74707 2.35008 5.97487C2.12228 6.20268 1.75293 6.20268 1.52513 5.97487Z"
                                fill="white"
                              />
                              <path
                                d="M5.64992 5.97487C5.42211 5.74707 5.42211 5.37772 5.64992 5.14991C5.87772 4.92211 6.24707 4.92211 6.47487 5.14991C6.70268 5.37772 6.70268 5.74707 6.47487 5.97487C6.24707 6.20268 5.87772 6.20268 5.64992 5.97487Z"
                                fill="white"
                              />
                              <path
                                d="M0.5 3.5C0.5 3.17783 0.761167 2.91667 1.08333 2.91667C1.4055 2.91667 1.66667 3.17783 1.66667 3.5C1.66667 3.82217 1.4055 4.08333 1.08333 4.08333C0.761167 4.08333 0.5 3.82217 0.5 3.5Z"
                                fill="white"
                              />
                              <path
                                d="M6.33333 3.5C6.33333 3.17783 6.5945 2.91667 6.91667 2.91667C7.23883 2.91667 7.5 3.17783 7.5 3.5C7.5 3.82217 7.23883 4.08333 6.91667 4.08333C6.5945 4.08333 6.33333 3.82217 6.33333 3.5Z"
                                fill="white"
                              />
                              <path
                                d="M5.64992 1.85008C5.42211 1.62228 5.42211 1.25293 5.64992 1.02513C5.87772 0.79732 6.24707 0.79732 6.47487 1.02513C6.70268 1.25293 6.70268 1.62228 6.47487 1.85008C6.24707 2.07789 5.87772 2.07789 5.64992 1.85008Z"
                                fill="white"
                              />
                              <path
                                d="M1.52513 1.85008C1.29732 1.62228 1.29732 1.25293 1.52513 1.02513C1.75293 0.79732 2.12228 0.79732 2.35008 1.02513C2.57789 1.25293 2.57789 1.62228 2.35008 1.85008C2.12228 2.07789 1.75293 2.07789 1.52513 1.85008Z"
                                fill="white"
                              />
                              <path
                                d="M3.41667 0.583333C3.41667 0.261167 3.67783 0 4 0L4.10486 0.00939822L4.20354 0.036495C4.42534 0.119087 4.58333 0.332759 4.58333 0.583333C4.58333 0.905499 4.32217 1.16667 4 1.16667C3.67783 1.16667 3.41667 0.905499 3.41667 0.583333Z"
                                fill="white"
                              />
                            </svg>
                            {booking.vehicleRegistrationNumber}
                          </h4>
                        ) : (
                          <h4>&zwnj;</h4>
                        )}
                        {!parking.isCancelled && canEditInformation && booking.vehicleRegistrationNumber && !isBookingActive ? (
                          <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                              d="M8.86651 2.87331L11.1244 5.13125M1.21874 12.998L4.00052 12.6006C4.0826 12.5889 4.15865 12.5509 4.21728 12.4922L12.8878 3.82176C13.0374 3.67212 13.0374 3.4295 12.8878 3.27985L10.7201 1.11223C10.5705 0.962589 10.3279 0.962589 10.1782 1.11223L1.50776 9.78272C1.44913 9.84134 1.4111 9.9174 1.39937 9.99948L1.00198 12.7813C0.983913 12.9077 1.09229 13.0161 1.21874 12.998Z"
                              stroke="#334B7C"
                            />
                          </svg>
                        ) : null}
                      </a>
                    </div>
                    <div className="grid-groups">
                      <div className="grid-group-one">
                        <div className="overview-dataline">{textKeys.bookingNumber || "Bookingnr.:"}</div>
                        <div className="overview-dataline">{textKeys.arrivalDate || "Indkørselsdato"}</div>
                        <div className="overview-dataline">{textKeys.departureDate || "Udkørselsdato"}</div>
                      </div>
                      <div className="grid-group-two">
                        <div className="overview-dataline">{booking.reference}</div>
                        <div className="overview-dataline">
                          {this.getDate(booking.arrivalDate)} ({booking.arrivalTime})
                        </div>
                        <div className="overview-dataline">
                          {this.getDate(booking.departureDate)} ({booking.departureTime})
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="editlinks">
                    {!parking.isCancelled && canEditBooking ? (
                      <Link to={`${path.AMMEND_EDIT_TIME()}${this.props.createQueryStrings(query)}`} className="link">
                        {textKeys.editDateTime || "ret dato eller tidspunkt"}
                      </Link>
                    ) : null}
                    {!parking.isCancelled &&
                    canEditExitTime &&
                    !canEditBooking &&
                    this.isBookingActive(booking) &&
                    (queryParam?.devpreview === "true" || textKeys.activateExtension) ? (
                      <Link to={`${path.AMMEND_EXTEND_TIME()}${this.props.createQueryStrings(query)}`} className="link">
                        {textKeys.editExitTime || "ret Udkørselstidspunkt"}
                      </Link>
                    ) : /* <button className="link"
                    {/* {!parking.isCancelled && canEditExitTime && !canEditBooking ?
                      // <Link to={`${path.AMMEND_EDIT_TIME()}${this.props.createQueryStrings(query)}`} className="link">{textKeys.editExitTime || "ret udkørselstidspunkt"}</Link>
                      <button className="link"
                        onClick={
                          () => this.props.performChangeBookingExitTime(
                            this.props.manageBookingResult,
                            booking.arrivalDate,
                            booking.arrivalTime,
                            booking.departureDate,
                            booking.departureTime,
                            booking.promotionCode,
                            booking.affiliateCode,
                            booking.reference,
                            booking.email,
                            false
                          )
                        }
                      >{textKeys.editExitTimeOnly || "ret udkørselstidspunkt"}</button> */
                    null}
                  </div>
                </div>
              ) : (
                ""
              )}
              <div className="clear"></div>
            </div>

            <BookingAmendmentProducts
              booking={booking}
              carPark={carPark}
              product={product}
              parking={parking}
              cancellationInfo={cancellationInfo}
              isUpsaleable={true}
              extras={extras}
              noLastStyling={true}
              isAmendment={false}
              loadedFromAmendment={true} //need a secondary amendment check for bookingUpsale. . .
              getExtraPrice={this.props.getExtraPrice}
              canEditBooking={this.canEditBooking}
              isBookingPending={this.isBookingPending}
              isBookingActive={this.isBookingActive}
              isFullValueCancellation={this.isFullValueCancellation}
              isExtendedRefundCancellation={this.isExtendedRefundCancellation}
              createQueryStrings={this.props.createQueryStrings}
              isCancelled
              {...this.props}
            />

            <div className="basket-total basket-total--full-width">
              <div className="basket-total__inner">
                <ul className="pre-calculation pre-calculation--no-border is-active">
                  <li className="pre-calculation__item">
                    <span className="label">{textKeys.calcTotal || "Subtotal"}</span>
                    <div className="pre-calculation__item__price">
                      <span className="currency">{textKeys.valuta || "DKK"}</span>
                      <span className="value"> {this.props.priceFormatter(booking.price + booking.promotionSaving, true)}</span>
                    </div>
                  </li>
                  {!booking.promotionCode || booking.promotionSaving === 0 ? (
                    ""
                  ) : (
                    <li className="pre-calculation__item">
                      <span className="label">
                        {textKeys.promotionCode || "Kampagnekode"}: {booking.promotionName}
                      </span>
                      <div className="pre-calculation__item__price">
                        <span className="currency">{textKeys.valuta || "DKK"}</span>
                        <span className="value"> -{this.props.priceFormatter(booking.promotionSaving, true)}</span>
                      </div>
                    </li>
                  )}
                  {!this.isFullValueCancellation() && this.isExtendedRefundCancellation() && refundGuarantee ? (
                    <li className="pre-calculation__item">
                      <span className="label">{refundGuarantee.name}</span>
                      <div className="pre-calculation__item__price">
                        <span className="currency">{textKeys.valuta || "DKK"}</span>{" "}
                        <span className="value">-{this.props.priceFormatter(this.props.getExtraPrice(refundGuarantee, booking), true)}</span>
                      </div>
                    </li>
                  ) : null}
                  {isCancelled ? (
                    <div className="pre-calculation__item">
                      <span className="label">{textKeys.refunded || "Refunderet"}</span>
                      <div className="pre-calculation__item__price">
                        <span className="currency">{textKeys.valuta || "DKK"}</span>{" "}
                        <span className="value">-{this.props.priceFormatter(refundedValue, true)}</span>
                      </div>
                    </div>
                  ) : null}
                </ul>
                <div className="end-result">
                  <h4>{textKeys.total || "Total"}</h4>
                  <div className="end-result__price">
                    <span className="currency">{textKeys.valuta || "DKK"}</span>
                    <span className="value"> {this.props.priceFormatter(booking.price, true)}</span>
                    {/* {isCancelled ?
                      <span className="value"> {this.props.priceFormatter(monetaryRefundValue)}</span>
                      : <span className="value"> {this.props.priceFormatter(monetaryRefundValue)}</span>
                    } */}
                  </div>
                </div>
                <a
                  href={`${endpoints.GENERATE_PDF_RECEIPT(this.props.manageBookingResult.booking.guid)}`}
                  target="_blank"
                  className="receipt-download"
                  rel="noreferrer"
                >
                  {textKeys.downloadReceipt || "Download Kvittering"}
                </a>
              </div>
            </div>
            {/*  */}
          </div>
        </section>
        <section className="deck deck--white deck--padding-top">
          <div className="w--narrow">
            <header className="enhanced-table__header amend-information-header">
              <h4 className="headline-sm">{textKeys.personalText ? textKeys.personalText.header || "Din information" : "Din information"}</h4>
              {!parking.isCancelled && canEditInformation ? (
                <Link to={`${path.AMMEND_EDIT_INFO()}${this.props.location.search}`} className="link">
                  {textKeys.editButton || "Redigér"}
                </Link>
              ) : null}
            </header>
            <table className="enhanced-table enhanced-table--fixed enhanced-table--no-labels">
              <tbody>
                <tr className="enhanced-table__row enhanced-table__row--body extra-padding-block">
                  <td className="enhanced-table__cell">
                    <div className="enhanced-table__cell__inner">
                      <span>
                        <strong>{textKeys.personalText ? textKeys.personalText.name || "Navn" : "Navn"}</strong>
                      </span>
                    </div>
                  </td>
                  <td className="enhanced-table__cell">
                    <div className="enhanced-table__cell__inner">
                      <span>
                        {booking.firstName} {booking.lastName}
                      </span>
                    </div>
                  </td>
                </tr>
                <tr className="enhanced-table__row enhanced-table__row--body extra-padding-block">
                  <td className="enhanced-table__cell">
                    <div className="enhanced-table__cell__inner">
                      <span>
                        <strong>{textKeys.personalText ? textKeys.personalText.email || "E-mail" : "E-mail"}</strong>
                      </span>
                    </div>
                  </td>
                  <td className="enhanced-table__cell">
                    <div className="enhanced-table__cell__inner">
                      <span>{booking.email}</span>
                    </div>
                  </td>
                </tr>
                <tr className="enhanced-table__row enhanced-table__row--body extra-padding-block">
                  <td className="enhanced-table__cell">
                    <div className="enhanced-table__cell__inner">
                      <span>
                        <strong>{textKeys.personalText ? textKeys.personalText.mobilenumber || "Mobil nr." : "Mobil nr."}</strong>
                      </span>
                    </div>
                  </td>
                  <td className="enhanced-table__cell">
                    <div className="enhanced-table__cell__inner">
                      <span>{booking.mobilePhone}</span>
                    </div>
                  </td>
                </tr>
                <React.Fragment>
                  <tr className="enhanced-table__row enhanced-table__row--body extra-padding-block">
                    <td className="enhanced-table__cell">
                      <div className="enhanced-table__cell__inner">
                        <span>
                          <strong>
                            {textKeys.vehichleText ? textKeys.vehichleText.vehicleRegistrationNumber || "Registreringsnr." : "Registreringsnr."}
                          </strong>
                        </span>
                      </div>
                    </td>
                    <td className="enhanced-table__cell">
                      <div className="enhanced-table__cell__inner">
                        <span>{booking.vehicleRegistrationNumber}</span>
                      </div>
                    </td>
                  </tr>
                  <tr className="enhanced-table__row enhanced-table__row--body extra-padding-block">
                    <td className="enhanced-table__cell">
                      <div className="enhanced-table__cell__inner">
                        <span>
                          <strong>{textKeys.vehichleText ? textKeys.vehichleText.vehicleMake || "Mærke" : "Mærke"}</strong>
                        </span>
                      </div>
                    </td>
                    <td className="enhanced-table__cell">
                      <div className="enhanced-table__cell__inner">
                        <span>{booking.vehicleMake}</span>
                      </div>
                    </td>
                  </tr>
                  <tr className="enhanced-table__row enhanced-table__row--body extra-padding-block">
                    <td className="enhanced-table__cell">
                      <div className="enhanced-table__cell__inner">
                        <span>
                          <strong>{textKeys.vehichleText ? textKeys.vehichleText.vehicleModel || "Model" : "Model"}</strong>
                        </span>
                      </div>
                    </td>
                    <td className="enhanced-table__cell">
                      <div className="enhanced-table__cell__inner">
                        <span>{booking.vehicleModel}</span>
                      </div>
                    </td>
                  </tr>
                  <tr className="enhanced-table__row enhanced-table__row--body extra-padding-block">
                    <td className="enhanced-table__cell">
                      <div className="enhanced-table__cell__inner">
                        <span>
                          <strong>{textKeys.vehichleText ? textKeys.vehichleText.vehicleColour || "Farve" : "Farve"}</strong>
                        </span>
                      </div>
                    </td>
                    <td className="enhanced-table__cell">
                      <div className="enhanced-table__cell__inner">
                        <span>{booking.vehicleColour}</span>
                      </div>
                    </td>
                  </tr>
                </React.Fragment>
              </tbody>
            </table>
          </div>
        </section>
        <section className="deck deck--white deck--extra-padding-bottom">
          <div className="w--wider">
            <div className={`action-buttons ${canEditBooking ? "" : "column-mode"}`}>
              {!parking.isCancelled && cancellationInfo ? ( // no cancellationinfor on booking after it has happened shortcut
                <>
                  {" "}
                  <button
                    className={`button button--medium button--negative rm-this-class rm-this-class-hide-default amendCancel amendButtons ${
                      canEditBooking ? "" : "d-none"
                    }`}
                    onClick={() => this.flipModalState()}
                  >
                    <span className="icon">
                      <svg className="svg-icon svg-icon--planeduo">
                        <use xmlnsXlink="http://www.w3.org/1999/xlink" xlinkHref="/dist/svg/symbols.svg#svg-planeduo">
                          &nbsp;
                        </use>
                      </svg>
                    </span>
                    <span className="text">{textKeys.cancelButton || "Annullér booking"}</span>
                  </button>
                  <button
                    className="button button--medium button--discreet amendResend amendButtons"
                    onClick={() => this.props.resendBookingReceipt(booking.guid)}
                  >
                    <span className="icon">
                      <svg className="svg-icon svg-icon--planeduo">
                        <use xmlnsXlink="http://www.w3.org/1999/xlink" xlinkHref="/dist/svg/symbols.svg#svg-planeduo">
                          &nbsp;
                        </use>
                      </svg>
                    </span>
                    <span className="text">{textKeys.resendBookingReceiptButton || "Gensend kvittering"}</span>
                  </button>
                  <p className={`amendAdditionalInfo`}>
                    {cancellationInfo.cancellationActionStatus === "CancellationEnabled"
                      ? `${textKeys.cancelWithFullRefund || "Du kan fortryde din booking og få refunderet "} ${this.props.priceFormatter(
                          fullRefundValue,
                        )} ${textKeys.refundUntil || " frem til "} ${this.getDate(new Date(booking.arrivalDate)).toLowerCase()} `
                      : cancellationInfo.cancellationActionStatus === "CancellationDisabledQuarantined"
                        ? `${
                            textKeys.refundQuarantined ||
                            "Det er ikke længere muligt at annullere din reservation, da der er under 1 time til indkørsel."
                          }`
                        : cancellationInfo.cancellationActionStatus === "CancellationDisabledPastEntryTime"
                          ? `${textKeys.refundNotAvailable || "Det er ikke længere muligt at annullere din reservation."}`
                          : null}
                    {/* <a href="https://info.parkering.cph.dk/vilk%C3%A5r-cph-parkering">{textKeys.readMore || "Se vores handelsbetingelser"}</a> */}
                  </p>
                </>
              ) : (
                ""
              )}
            </div>
          </div>
        </section>
        <span dangerouslySetInnerHTML={{ __html: `<!-- ${JSON.stringify(this.props.manageBookingResult)} -->` }}></span>
        {this.state.isModalLoaded && (
          <ActionModal
            confirmActionHeader={textKeys.confirmActionHeader}
            confirmText={textKeys.confirmText}
            confirmButton={textKeys.confirmButton}
            closeModal={this.flipModalState}
            actionMethod={this.handleCancellation}
            manageBookingResult={this.props.manageBookingResult}
          />
        )}
      </div>
    )
  }
}

export default AmendManage
